import { useQuery } from '@tanstack/react-query'
import { axios } from 'apis/axios'
import { ExtractFnReturnType, QueryConfig } from 'apis/queryConfig'
import { IuserDetails } from 'types/User'

interface Iprops {
  queryParams?: Record<string, any>
}

export const getUserDetails = ({ queryParams }: Iprops): Promise<IuserDetails> => {
  return axios.get('oe/users/me/', { params: queryParams }).then(res => {
    return res.data
  })
}


type QueryFnType = typeof getUserDetails
interface IUseUserDetails extends Iprops {
  config: QueryConfig<QueryFnType>
}

export const useUserDetails = ({ queryParams, config }: IUseUserDetails) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getUserDetails', queryParams],
    queryFn: () => getUserDetails({ queryParams }),
    ...config

  })
}